import React, { Component } from 'react';

//componentes
import CxP from './cxp'

class Index extends Component {

    render(){
        return(
            <div>
                <CxP />
            </div>
        );
    }

}
export default Index;